import React, { Fragment } from "react";
import { Dropdown } from "primereact/dropdown";
import { FormLabel, LabelWrapper } from "../inputtext/inputtextStyle";
import PropTypes from "prop-types";

function FormDropdown({
  style,
  label,
  valueAsObj,
  options,
  optionLabel,
  onChange,
  required,
  ...rest
}) {
  return (
    <Fragment>
      {label === undefined ? (
        <Fragment></Fragment>
      ) : (
        <LabelWrapper>
          <FormLabel>
            {label}{" "}
            {required ? (
              <span
                style={{
                  color: "#f10000",
                }}
              >
                *
              </span>
            ) : (
              ""
            )}
          </FormLabel>
        </LabelWrapper>
      )}
      <Dropdown
        variant="filled"
        value={valueAsObj}
        options={options}
        optionLabel={optionLabel}
        onChange={onChange}
        style={{ ...style, height: "40px" }}
        {...rest}
      />
    </Fragment>
  );
}

FormDropdown.propTypes = {
  style: PropTypes.object, // Add this line
  label: PropTypes.string,
  valueAsObj: PropTypes.object,
  optionLabel: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  options: PropTypes.object,
};
export default FormDropdown;
